import axios from 'axios';
import apisUrls from '../urls';

const changeWebsiteServiceStatusApi = (values) => {
  return axios.post(apisUrls?.changeWebsiteServiceStatus, values, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default changeWebsiteServiceStatusApi;
